import React from 'react'
import { BrowserRouter, Route, RouterProps } from 'react-router-dom'

import { RouterContext } from '../Router'
import { TContextValue } from '../Router/RouterContext'

type TRouterContextProvider = {
  children?: React.ReactNode
}
const RouterContextProvider = (
  props: TRouterContextProvider,
): React.ReactElement => {
  const { children } = props

  return (
    <BrowserRouter>
      <Route>
        {(routeProps: RouterProps) => (
          <RouterContext.Provider value={routeProps as any}>
            {children}
          </RouterContext.Provider>
        )}
      </Route>
    </BrowserRouter>
  )
}

export default RouterContextProvider
